import axios from 'axios';
import apiConfig from '../api.config';

export default function allHotelsRequest() {
  const {
    host,
    URIs: { allHotels },
  } = apiConfig;

  const uri = `${host}${allHotels}`;

  return axios
    .get(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
